import { FormValues } from "../../types";
import { bffApi } from "../../../../services/bff/bffApi";
import {BaseService} from "../../../../global/classes";

export default class BillingPanelService extends BaseService {
  getBillings = async (page: number, pageSize: number, filter?: FormValues) => {
    const paged = true;
    const month = filter?.month;
    const year = filter?.year;
    const merchantId = this.selectedCompany?.merchantId ?? filter?.merchantId ?? null;
    const serialNumber = filter?.serialNumber || null;
    const billingType = filter?.billingType !== -1 ? filter?.billingType : null;
    const commercialHierId = null;
    const commercialUserEmail = this.commercialUserEmail;

    try {
      const response = await bffApi.get(
        `/api/gcb/v1/terminalbillingmanagement/billing`,
        {
          params: {
            currentPage: page,
            pageSize: pageSize,
            paged: paged,
            month: month,
            year: year,
            merchantId: merchantId,
            serialNumber: serialNumber,
            billingType: billingType,
            commercialHierId: commercialHierId,
            email: commercialUserEmail,
          },
        }
      );

      return response.data;
    } catch (error) {
      throw error;
    }
  };

  downloadBillingPanelXls = async (filter?: FormValues) => {
    const paged = false;
    const month = filter?.month;
    const year = filter?.year;
    const merchantId = this.selectedCompany?.merchantId ?? filter?.merchantId ?? null;
    const billingType = filter?.billingType !== -1 ? filter?.billingType : null;
    const commercialUserEmail = this.commercialUserEmail;

    try {
      const response = await bffApi.get(
         `/api/gcb/v1/terminalbillingmanagement/billingPanel-xls`,
        {
          params: {
            merchantId: merchantId,
            year: year,
            month: month,
            billingType: billingType,
            email: commercialUserEmail,
          },
          responseType: "blob",
        }
      );

      return response.data;
    } catch (error) {
      throw error;
    }
  };
}
